import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT_INFO, LOGO_SRC } from "../i18n/translations";

const Footer = () => {
  const { t } = useLang();

  return (
    <footer data-testid="site-footer" className="bg-[#001125] text-white border-t border-white/10">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img src={LOGO_SRC} alt="ARIIVA" loading="lazy" decoding="async" className="h-14 w-auto brightness-0 invert" />
            <p className="mt-6 text-white/65 max-w-sm font-editorial font-light text-sm leading-relaxed">{t.footer.tagline}</p>
          </div>

          <div className="md:col-span-2">
            <p className="text-[10px] tracking-[0.3em] uppercase text-white/45 mb-4 font-semibold">{t.footer.sections.company}</p>
            <ul className="space-y-3 text-sm text-white/80">
              <li><a href="#about" className="hover:text-white">{t.nav.about}</a></li>
              <li><a href="#sectors" className="hover:text-white">{t.nav.sectors}</a></li>
              <li><a href="#impact" className="hover:text-white">{t.nav.projects}</a></li>
              <li><a href="#contact" className="hover:text-white">{t.nav.contact}</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-[10px] tracking-[0.3em] uppercase text-white/45 mb-4 font-semibold">{t.footer.sections.divisions}</p>
            <ul className="space-y-3 text-sm text-white/80">
              <li><a href="#divisions" className="hover:text-white">Infra</a></li>
              <li><a href="#divisions" className="hover:text-white">Assets</a></li>
              <li><a href="#divisions" className="hover:text-white">Real Estate</a></li>
              <li><a href="#divisions" className="hover:text-white">Projects</a></li>
              <li><a href="#divisions" className="hover:text-white">Digital</a></li>
              <li><a href="#divisions" className="hover:text-white">Human</a></li>
              <li><a href="#divisions" className="hover:text-white">Advisory</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.3em] uppercase text-white/45 mb-4 font-semibold">{t.footer.sections.contact}</p>
            <ul className="space-y-3 text-sm text-white/80">
              <li><a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-white break-all">{CONTACT_INFO.email}</a></li>
              <li><a href={CONTACT_INFO.linkedin} target="_blank" rel="noreferrer" className="hover:text-white">LinkedIn</a></li>
              <li><a href={CONTACT_INFO.instagram} target="_blank" rel="noreferrer" className="hover:text-white">Instagram</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40 tracking-wide">
          <span>© {new Date().getFullYear()} ARIIVA. {t.footer.rights}</span>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white/80">{t.footer.privacy}</a>
            <span className="tracking-[0.3em] uppercase">Estrategia · Infraestructura · Tecnología · Activos</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
